import { styled } from "theme/default/styled";
import { setFlexDFAIC } from "theme/setter/setFlexValues/setFlexDFAIC";

export const SInvoicesHeader = styled.div`
  position: relative;

  ${setFlexDFAIC};
`;
